/**
 * Component: Video
 * ------------------------------------------------------------------------------
 *
 * @namespace video
 */

import { on } from '../helpers/utils';

/**
 * Export a new store selector instance.
 */
export default () => {
  function init() {
    const videos = document.querySelectorAll('[js-video]');

    videos.forEach((video) => {
      const button = video.nextElementSibling;

      on('click', video, () => {
        videoState(video, button);
      });

      on('click', button, () => {
        videoState(video, button);
      });
    });
  }

  function videoState(video, button) {
    if (video.paused == true) {
      video.play();
      button.style.opacity = '0';

      window.setTimeout(() => {
        button.style.zIndex = '-1';
      }, 300);

      return;
    }

    video.pause();
    button.style.opacity = '1';
    button.style.zIndex = '1';
  }

  /**
   * Expose public interface
   */
  return Object.freeze({
    init,
  });
};
